import Range from './range';
import defaults from './progress.defaults';
defaults.init();

export default class Progress extends Range {
  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);

    // this.addApi(this, 'text', () =>
    //   this._checkDataOption('text', this._controlOptions.panel && this._controlOptions.panel.HTML)
    // );
  }

  renderElement() {
    const el = super.renderElement();
    el.classList.add('io-progress-default');

    return el;
  }
}
